// extracted by mini-css-extract-plugin
module.exports = {"Body":"cookie_Body__Qc7ou","slideUp":"cookie_slideUp__iJ7q7","Text":"cookie_Text__PBiyR","Link":"cookie_Link__pVgul"};